import axios from 'axios';
import { waitForJob } from '@/utils/frameDownload';

export async function uploadToProject(file, notebookId, onPhase = () => {}) {
  onPhase('Uploading…');
  const { data: presigned } = await axios.post('/api/etl_module/upload/', {
    filename: file.name,
    content_type: file.type || 'application/octet-stream',
  });
  const put = await fetch(presigned.upload_url, {
    method: 'PUT',
    headers: { 'Content-Type': file.type || 'application/octet-stream' },
    body: file,
  });
  if (!put.ok) throw new Error(`S3 upload failed (${put.status})`);
  if (/\.(png|jpe?g)$/i.test(file.name)) return { key: presigned.s3_key, frames: [], note: '' };
  onPhase('Reading the table…');
  let frames = [];
  let note = '';
  try {
    const { data: started } = await axios.post('/api/impact_analytics/frames/from_upload/', {
      s3_key: presigned.s3_key, notebook: notebookId || null,
    });
    const job = await waitForJob(started.job_id);
    if (job.status === 'completed') {
      frames = (job.result_data && job.result_data.frames) || [];
      if (job.result_data && job.result_data.error) note = job.result_data.error;
    } else {
      note = job.error_message || 'The file was uploaded but could not be registered as a table.';
    }
  } catch (err) {
    note = err?.response?.data?.error || 'The file was uploaded but could not be registered as a table.';
  }
  return { key: presigned.s3_key, frames, note };
}
